import { useQuery } from '@tanstack/react-query';
import { clients } from '../clients';
import { QueryKey } from './QueryKey';

export function useTags() {
  const {
    data: tags,
    isLoading: tagsLoading,
    isError: tagsError,
  } = useQuery({
    queryKey: [QueryKey.Tag],
    queryFn: async () => {
      return await clients.tag.getAllTags();
    },
  });

  return {
    tags: tags?.data,
    tagsLoading,
    tagsError,
    total: tags?.total,
  };
}
